/* mp-sticky-buy-bar.js — wires the native PDP sticky bar to the REAL product
   form. Never reimplements Shopify's variant matching, price calculation, or
   cart submission — it only mirrors values onto/from the real elements and
   triggers their real events/clicks, so all of that logic keeps running
   exactly as it does for the main form. */
(function () {
  function init(bar) {
    var sectionId = bar.getAttribute('data-section-id');
    if (!sectionId) return;

    var realAddToCart = document.getElementById('AddToCart-' + sectionId);
    var realQuantity = document.getElementById('Quantity-' + sectionId);
    var realPriceEl = document.querySelector('.product__price');
    var realOptionSelectors = document.querySelectorAll('.single-option-selector-' + sectionId);

    if (!realAddToCart) return; // nothing to attach to on this page

    // packaging-prominence.js renders its own "Select options below" variant
    // cards, writing to the real .single-option-selector on click but never
    // listening back for changes to it (confirmed: no such listener exists in
    // that file) — so when THIS bar changes the real select, Shopify's own
    // price/variant matching (theme.js's slate.Variants, bound directly on
    // each .single-option-selector) still runs correctly, but the cards never
    // re-highlight, since nothing tells them a change happened. Fixed by
    // resolving the newly-matched variant id from the hidden master select
    // (#ProductSelect-<sectionId>, synchronously updated by theme.js's
    // _updateMasterSelect once a matching variant is found) and clicking the
    // corresponding real card — same effect as the shopper clicking it
    // themselves, including packaging-prominence's own radio-active toggle.
    var masterSelect = document.getElementById('ProductSelect-' + sectionId);
    function syncPackagingProminenceCard() {
      if (!masterSelect) return;
      var variantId = masterSelect.value;
      if (!variantId) return;
      var card = document.querySelector('.packaging-prominence .variant-card[data-variant-id="' + variantId + '"]');
      if (card && !card.classList.contains('radio-active')) card.click();
    }

    // ---- Variant option sync (sticky -> real, and real -> sticky) ----
    // Custom dropdown (button + listbox) instead of a native <select>, so the
    // open option list can actually have rounded corners. It never decides
    // variants itself — picking an item just sets realSelect.value and fires
    // 'change', so Shopify's own variant-matching runs exactly as it does for
    // the main form.
    var stickyDropdowns = bar.querySelectorAll('.mp-sbb-select');
    stickyDropdowns.forEach(function (dropdown) {
      var index = dropdown.getAttribute('data-index');
      var realSelect = null;
      realOptionSelectors.forEach(function (el) {
        if (el.getAttribute('data-index') === index) realSelect = el;
      });
      if (!realSelect) return;

      var trigger = dropdown.querySelector('.mp-sbb-select-trigger');
      var valueEl = dropdown.querySelector('.mp-sbb-select-value');
      var listbox = dropdown.querySelector('.mp-sbb-select-listbox');
      var options = Array.prototype.slice.call(dropdown.querySelectorAll('.mp-sbb-select-option'));

      function closeListbox() {
        listbox.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }
      function openListbox() {
        listbox.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
      function displayValue(value) {
        valueEl.textContent = value;
        options.forEach(function (opt) {
          var isMatch = opt.getAttribute('data-value') === value;
          opt.classList.toggle('mp-sbb-select-option--active', isMatch);
          opt.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        });
      }

      trigger.addEventListener('click', function () {
        if (listbox.hidden) openListbox();
        else closeListbox();
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openListbox();
          var active = dropdown.querySelector('.mp-sbb-select-option--active') || options[0];
          if (active) active.focus();
        }
      });

      options.forEach(function (opt, i) {
        opt.addEventListener('click', function () {
          var value = opt.getAttribute('data-value');
          displayValue(value);
          closeListbox();
          trigger.focus();
          realSelect.value = value;
          realSelect.dispatchEvent(new Event('change', { bubbles: true }));
          syncPackagingProminenceCard();
        });
        opt.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            (options[i + 1] || options[0]).focus();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            (options[i - 1] || options[options.length - 1]).focus();
          } else if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            opt.click();
          } else if (e.key === 'Escape') {
            closeListbox();
            trigger.focus();
          }
        });
      });

      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) closeListbox();
      });

      var onRealSelectChange = function () {
        displayValue(realSelect.value);
      };
      realSelect.addEventListener('change', onRealSelectChange);
      // packaging-prominence.js (the "Select options below" card picker) updates
      // this select via jQuery's .val() + .trigger('change'), which only reaches
      // jQuery-bound handlers, not native addEventListener ones. jQuery is
      // lazy-loaded on this theme (type="lazyJs", deferred until first
      // scroll/interaction) and isn't available yet at this defer-time init,
      // so it's polled for the same way packaging-prominence.js does.
      (function bindJqueryChange() {
        if (window.jQuery) {
          window.jQuery(realSelect).on('change', onRealSelectChange);
        } else {
          setTimeout(bindJqueryChange, 50);
        }
      })();
    });

    // ---- Quantity sync (two-way) ----
    // Bound on both 'input' and 'change': the real field is a bare native
    // <input type="number"> with no custom stepper JS, so typing fires
    // 'input' but browser/OS-native spinner or blur-confirm interactions on
    // some devices only fire 'change' — listening for both keeps the two
    // fields from drifting out of sync regardless of how the value was set.
    var stickyQty = bar.querySelector('.mp-sbb-qty-input');
    if (stickyQty && realQuantity) {
      var pushStickyToReal = function () {
        if (stickyQty.value > 0 && realQuantity.value !== stickyQty.value) {
          realQuantity.value = stickyQty.value;
          realQuantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      stickyQty.addEventListener('input', pushStickyToReal);
      stickyQty.addEventListener('change', pushStickyToReal);

      var pushRealToSticky = function () {
        if (realQuantity.value > 0 && stickyQty.value !== realQuantity.value) {
          stickyQty.value = realQuantity.value;
        }
      };
      realQuantity.addEventListener('input', pushRealToSticky);
      realQuantity.addEventListener('change', pushRealToSticky);

      var minusBtn = bar.querySelector('.mp-sbb-qty-minus');
      var plusBtn = bar.querySelector('.mp-sbb-qty-plus');
      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          var val = Math.max(1, (parseInt(stickyQty.value, 10) || 1) - 1);
          stickyQty.value = val;
          stickyQty.dispatchEvent(new Event('input', { bubbles: true }));
        });
      }
      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          var val = (parseInt(stickyQty.value, 10) || 1) + 1;
          stickyQty.value = val;
          stickyQty.dispatchEvent(new Event('input', { bubbles: true }));
        });
      }
    }

    // ---- Price + sold-out state mirror (observe the real price/button, copy into sticky bar) ----
    var stickyPrice = bar.querySelector('.mp-sbb-price');
    var stickyAddToCart = bar.querySelector('.mp-sbb-add-to-cart');

    if (realPriceEl && stickyPrice) {
      var syncPrice = function () {
        // Target the exact money element directly (snippets/product-price.liquid's
        // .price-item--sale / .price-item--regular <strong>) rather than reading
        // .textContent/.innerText off the whole .product__price container, which
        // also holds an inline <style> tag and visually-hidden a11y labels
        // ("Regular price"/"Sale price") that would otherwise get copied in too.
        var priceDl = realPriceEl.querySelector('.price');
        var isOnSale = priceDl && priceDl.classList.contains('price--on-sale');
        var priceItem = realPriceEl.querySelector(isOnSale ? '.price-item--sale' : '.price-item--regular');
        if (priceItem) {
          stickyPrice.textContent = priceItem.textContent.trim().replace(/\s+/g, ' ');
        }
      };
      syncPrice();
      new MutationObserver(syncPrice).observe(realPriceEl, { childList: true, subtree: true, characterData: true });
    }

    // ---- Discount badge mirror (reuses the real "X% OFF" widget's own live-updating calculation) ----
    var stickyDiscount = bar.querySelector('.mp-sbb-discount');
    var realDiscountBadge = document.querySelector('[data-savings-badge]');
    var realDiscountPercent = document.querySelector('[data-savings-percent]');
    if (stickyDiscount && realDiscountBadge && realDiscountPercent) {
      var syncDiscount = function () {
        var isVisible = window.getComputedStyle(realDiscountBadge).display !== 'none';
        if (isVisible) {
          // realDiscountPercent's text already includes a trailing "%" (from
          // product-price.liquid's "{{ percentage_off }}%"), so only append "OFF".
          stickyDiscount.textContent = realDiscountPercent.textContent.trim() + ' OFF';
          stickyDiscount.style.display = '';
        } else {
          stickyDiscount.style.display = 'none';
        }
      };
      syncDiscount();
      new MutationObserver(syncDiscount).observe(realDiscountBadge, {
        attributes: true, attributeFilter: ['style', 'class'], childList: true, subtree: true, characterData: true
      });
    }

    if (stickyAddToCart) {
      var syncDisabled = function () {
        stickyAddToCart.disabled = realAddToCart.disabled;
      };
      syncDisabled();
      new MutationObserver(syncDisabled).observe(realAddToCart, { attributes: true, attributeFilter: ['disabled'] });

      stickyAddToCart.addEventListener('click', function () {
        realAddToCart.click();
      });
    }

    // ---- Show/hide once the real Add to Cart button scrolls out of view ----
    if (window.mpStickyBar) {
      window.mpStickyBar.watch(bar, realAddToCart);
    }
  }

  function initAll() {
    document.querySelectorAll('.mp-sticky-buy-bar').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
